// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m["default"] || m;
};

exports.components = {
  "component---lessons-10-mdx": function componentLessons10Mdx() {
    return import("./../../../lessons/10.mdx"
    /* webpackChunkName: "component---lessons-10-mdx" */
    );
  }
};